import React from 'react';
import { connect } from 'react-redux';

import { STEP_MODAL_DONE_STATUS_VISIBILITY_TIME } from '../../../common/constants';
import { getWeb3Wrapper } from '../../../services/web3_wrapper';
import { lockToken, unlockToken } from '../../../store/blockchain/actions';
import { getEstimatedTxTimeMs, getStepsModalCurrentStep } from '../../../store/selectors';
import { stepsModalAdvanceStep } from '../../../store/ui/actions';
import { sleep } from '../../../util/sleep';
import { tokenSymbolToDisplayString } from '../../../util/tokens';
import { StepToggleTokenLock, StoreState, Token } from '../../../util/types';

import { BaseStepModal } from './base_step_modal';
import { StepItem } from './steps_progress';
import { isMobile } from "react-device-detect";

const I18n = require('i18n-js');

interface OwnProps {
    buildStepsProgress: (currentStepItem: StepItem) => StepItem[];
}
interface StateProps {
    estimatedTxTimeMs: number;
    step: StepToggleTokenLock;
}

interface DispatchProps {
    onLockToken: (token: Token) => Promise<any>;
    onUnlockToken: (token: Token) => Promise<any>;
    advanceStep: () => void;
}

type Props = OwnProps & StateProps & DispatchProps;

class ToggleTokenLockStep extends React.Component<Props> {
    public render = () => {
        const { buildStepsProgress, estimatedTxTimeMs, step } = this.props;
        const { context, isUnlocked, token } = step;
        const tokenSymbol = tokenSymbolToDisplayString(token.symbol);
        const meta = isMobile ? 'Metamask' : '...';
        const title = context === 'order' ? I18n.t('orderSetup') : isUnlocked ? I18n.t('lockToken') : I18n.t('unlockToken');
        const confirmCaption = isUnlocked ? I18n.t('confirmMetamaskLock', { tokenSymbol }).replace(meta, 'dApp') : I18n.t('confirmMetamaskUnlock', { tokenSymbol }).replace(meta, 'dApp');
        // const confirmCaption = `Confirm on Metamask to ${
        //     isUnlocked ? 'lock' : 'unlock'
        // } ${tokenSymbol} for trading on 0x.`;
        const loadingCaption = isUnlocked ? I18n.t('lockingTokenSymbol', { tokenSymbol }) : I18n.t('unlockingTokenSymbol', { tokenSymbol });
        // ? `Locking ${tokenSymbol}. You won't be able to use it for trading until you unlock it again`
        // : `Unlocking ${tokenSymbol}. It will remain unlocked for future trades`;
        const doneCaption = isUnlocked ? I18n.t('lockedTokenSymbol', { tokenSymbol }) : I18n.t('unlockedTokenSymbol', { tokenSymbol });
        // ? `Locked ${tokenSymbol}. You won't be able to use it for trading until you unlock it again`
        // : `Unlocked ${tokenSymbol}. It will remain unlocked for future trades`;
        const errorCaption = isUnlocked ? I18n.t('lockingTokenSymbolFailed', { tokenSymbol }) : I18n.t('unlockingTokenSymbolFailed', { tokenSymbol }); // 'Locking' : 'Unlocking'} ${tokenSymbol} failed.`;
        const loadingFooterCaption = I18n.t('waitingForConfirmation');
        const doneFooterCaption = ' ' + (!isUnlocked ?  I18n.t('tokenSymbolUnlocked', { tokenSymbol }) : I18n.t('tokenSymbolLocked', { tokenSymbol }))  ;// ` ${tokenSymbol} Unlocked!` : ` ${tokenSymbol} Locked!`;

        return (
            <BaseStepModal
                step={step}
                title={title}
                confirmCaption={confirmCaption}
                loadingCaption={loadingCaption}
                doneCaption={doneCaption}
                errorCaption={errorCaption}
                loadingFooterCaption={loadingFooterCaption}
                doneFooterCaption={doneFooterCaption}
                buildStepsProgress={buildStepsProgress}
                estimatedTxTimeMs={estimatedTxTimeMs}
                runAction={this._toggleToken}
                showPartialProgress={true}
            />
        );
    };

    private readonly _toggleToken = async ({ onLoading, onDone, onError }: any) => {
        const { step, advanceStep, onLockToken, onUnlockToken } = this.props;

        const toggleToken = step.isUnlocked ? onLockToken : onUnlockToken;

        try {
            const web3Wrapper = await getWeb3Wrapper();
            const txHash = await toggleToken(step.token);
            onLoading();

            await web3Wrapper.awaitTransactionSuccessAsync(txHash);
            onDone();
            await sleep(STEP_MODAL_DONE_STATUS_VISIBILITY_TIME);
            advanceStep();
        } catch (err) {
            onError(err);
        }
    };
}

const mapStateToProps = (state: StoreState): StateProps => {
    return {
        estimatedTxTimeMs: getEstimatedTxTimeMs(state),
        step: getStepsModalCurrentStep(state) as StepToggleTokenLock,
    };
};

const ToggleTokenLockStepContainer = connect(
    mapStateToProps,
    (dispatch: any) => {
        return {
            onLockToken: (token: Token) => dispatch(lockToken(token)),
            onUnlockToken: (token: Token) => dispatch(unlockToken(token)),
            advanceStep: () => dispatch(stepsModalAdvanceStep()),
        };
    },
)(ToggleTokenLockStep);

export { ToggleTokenLockStep, ToggleTokenLockStepContainer };
